import { createSlice } from '@reduxjs/toolkit';

export const customCounsellingFiveSlice = createSlice({
  name: 'customCounsellingFive',
  initialState: {
    allDataFive: null,
  },
  reducers: {
    setAllDataFive: (state, action) => {
      state.allDataFive = action.payload;
    },
  },
});

export const { setAllDataFive } = customCounsellingFiveSlice.actions;
export default customCounsellingFiveSlice.reducer;
